export const pricePackageANumeric = 2088;
export const pricePackageBNumeric = 3016;
export const pricePackageCNumeric = 1650
export const pricePackageA = `€ ${pricePackageANumeric}`;
export const pricePackageB = `€ ${pricePackageBNumeric}`;
